<app-report-filter></app-report-filter>
<app-report-group (groupChanged)="groupChanged($event)"></app-report-group>
<div class="mt-2">
  <button class="btn btn-primary" (click)="runReport()">Run Report <i class="fas fa-spinner fa-pulse" *ngIf="runningReport" aria-hidden="true"></i></button>
</div>
<app-report-results [data]="resultingData"></app-report-results>
